export default function TermsPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
      
      <div className="prose prose-lg">
        <p className="text-gray-600 mb-6">Last updated: February 18, 2026</p>

        <h2>1. Service Description</h2>
        <p>
          Residual Vault is an <strong>educational platform and data aggregation service</strong>. 
          We provide:
        </p>
        <ul>
          <li>Educational courses about decentralized finance (DeFi) and yield strategies</li>
          <li>Comparison data for publicly available blockchain protocols</li>
          <li>Portfolio tracking and analytics tools</li>
          <li>Links to third-party protocols (we do not execute transactions)</li>
        </ul>

        <h2>2. What We Don't Do</h2>
        <p>Residual Vault does NOT:</p>
        <ul>
          <li>Buy, sell, trade, or hold cryptocurrency on your behalf</li>
          <li>Execute transactions or interact with blockchain protocols</li>
          <li>Provide financial, investment, or legal advice</li>
          <li>Act as a broker, exchange, or custodian</li>
          <li>Process cryptocurrency payments</li>
        </ul>

        <h2>3. Educational Purpose</h2>
        <p>
          All information provided is for <strong>educational purposes only</strong>. 
          We aggregate publicly available data from blockchain protocols to help users 
          learn about and compare different yield-bearing opportunities.
        </p>

        <h2>4. Third-Party Links</h2>
        <p>
          We provide links to third-party protocol websites. When you click these links,
          you leave our platform and interact directly with those protocols. We are not
          responsible for their services, terms, or actions.
        </p>

        <h2>5. No Investment Advice</h2>
        <p>
          Nothing on this platform constitutes financial, investment, legal, or tax advice.
          Always consult with qualified professionals before making financial decisions.
        </p>

        <h2>6. Subscription Services</h2>
        <p>
          Our subscription plans provide access to:
        </p>
        <ul>
          <li>Premium educational content and courses</li>
          <li>Advanced data analytics and comparison tools</li>
          <li>Portfolio tracking features</li>
          <li>API access for data retrieval</li>
        </ul>

        <h2>7. Data Accuracy</h2>
        <p>
          We aggregate data from public blockchain sources and third-party APIs. 
          While we strive for accuracy, we cannot guarantee that all data is error-free 
          or up-to-date. Always verify information independently.
        </p>

        <h2>8. User Responsibilities</h2>
        <p>You agree to:</p>
        <ul>
          <li>Use the platform for educational purposes</li>
          <li>Conduct your own research before making decisions</li>
          <li>Understand the risks of blockchain protocols</li>
          <li>Comply with all applicable laws in your jurisdiction</li>
        </ul>

        <h2>9. Limitation of Liability</h2>
        <p>
          Residual Vault is not liable for any losses resulting from your use of 
          third-party protocols, investment decisions, or actions taken based on 
          information provided on our platform.
        </p>

        <h2>10. Contact</h2>
        <p>
          Questions about these terms? Contact us at: support@residualvault.com
        </p>
      </div>
    </div>
  );
}
